import { Toast } from "antd-mobile";
import { businessGetAccountInfo as _businessGetAccountInfo, getDepositDetail } from "@/apis/crypto";
import QRCode from "qrcode";
import { StateCreator, create } from 'zustand';
import { useParams, useSearchParams } from 'react-router-dom';
import { useUserAuthContext } from "@/routes/routesAuths/userAuth";
import {  useMemo } from "react";
import { useConfigStore } from "@/stores";
import { usePaymentsStore } from "@/stores/payments";
import { getServerTime } from "@/utils/tool";
import { useUnmount } from "ahooks";
import { Payments } from "@/constants";

type CryptoAccountInfo = {
  address: string,
  otcTicker: string,
}
type CryptoState = {
  cryptoAccountInfo: CryptoAccountInfo
}

type CryptoAction = {
  businessGetAccountInfo: (val: string) => void,
  updateQRcode: (str: string) => void
}

type CryptoStore = CryptoState & CryptoAction



export const initCryptoStore: StateCreator<CryptoStore> = (set, get) => {
  return {
    cryptoAccountInfo: {
      address: "",
      otcTicker: "",
    },

    businessGetAccountInfo: async (val: string) => {
      const { ok, data, msg, ...rest } = await _businessGetAccountInfo({ type: val });

      const { updateQRcode } = get();
      if (ok) {
        set({ cryptoAccountInfo: data });
        updateQRcode(data.address);
      } else {
        Toast.show(msg);
      }

      return { ok, data, msg, ...rest };
    },
    updateQRcode: (str: string) => {
      const { cryptoAccountInfo } = get();
      QRCode.toDataURL(str || cryptoAccountInfo.address).then((url) => {
        
        const $QRcode = document.querySelector(".QRcode");
        $QRcode && $QRcode.setAttribute("src", url);
      });
    }
  }
}
export const useCryptoStore = create<CryptoStore>(initCryptoStore);
export const useCryptoMerchant = () => {
  const userInfo = useUserAuthContext();
  const [searchParams] = useSearchParams();
  const isCryptoMerchant = useMemo(() => {//是否是商家
    return searchParams.get('m') === '1' || searchParams.get('m') === '2';
  }, [searchParams]);

  const isPMerchant = useMemo(() => {//是否超级商家
    return searchParams.get('m') === '2';
  }, [searchParams]);

  const amICryptoMerchant = useMemo(() => {
    return userInfo.user.BusinessStatus === 1;
  }, [userInfo.user.BusinessStatus])
  return {
    isCryptoMerchant,
    isPMerchant,
    amICryptoMerchant,
    ApiPath: isCryptoMerchant ? 'Business' : '',
    BuyerApiPath: isCryptoMerchant && amICryptoMerchant ? 'Business' : ''
  }
}

export const useCryptoPayments= () => {
  const [searchParams] = useSearchParams();
  const params = useParams();
  const configStore = useConfigStore();
  // 格式化后的支付方式列表
  const [formatPayments,userPayments] = usePaymentsStore((state) => [
    state.formatPayments,
    state.payments,
  ]);



  const isMerchant = useMemo(() => {
    return searchParams.get('m') === '1' || searchParams.get('m') === '2' || params?.type === "merchant";
  }, [ searchParams, params?.type]);

  //超级商家
  const isProfession = useMemo(() => {
    return searchParams.get('m') === '2' || params?.type === "professionBusiness";
  }, [ searchParams, params?.type]);

  //商家wx zfb开关
  const hideAlipayWechatAtMerchantPage = useMemo(() => {
    return `${configStore.config?.businessAlipayWechatWebStatus}` !== '1';
  }, [configStore.config?.businessAlipayWechatWebStatus])

  //超级商家wx zfb开关
  const hideAlipayWechatProfessionMerchant = useMemo(() => {
    return `${configStore.config?.professionBusinessAlipayWechatWebStatus}` !== '1';
  }, [configStore.config?.professionBusinessAlipayWechatWebStatus])

  const hideAlipayWechat = useMemo(() => {
    return isMerchant && hideAlipayWechatAtMerchantPage;
  }, [ isMerchant, hideAlipayWechatAtMerchantPage]);

  const hideProfessionAlipayWechat = useMemo(() => {
    return isProfession && hideAlipayWechatProfessionMerchant;
  }, [ isProfession, hideAlipayWechatProfessionMerchant]);


  const normalPayments = useMemo(() => {
    const obj:any = {};
    for (const key in formatPayments) {
      const element = formatPayments[key as `${Payments}`];
      obj[key] = { ...element };
      // 筛选普通商家收付
      obj[key].list = element?.list?.filter((item:any) => !item.isMerchant && !item.isProfession) || [];
    }
    return obj;
  }, [formatPayments]);

  const merchantPayments = useMemo(() => {
    const obj:any = {};
    for (const key in formatPayments) {
      const element = formatPayments[key as  `${Payments}`];
      obj[key] = { ...element };
      obj[key].list = element?.list?.filter((item:any) => isProfession ? item.isProfession : item.isMerchant)||[];
    }
    return obj;
  }, [formatPayments]);

  return  {
    isMerchant,
    isProfession,
    hideAlipayWechat,
    hideAlipayWechatAtMerchantPage,
    hideProfessionAlipayWechat,
    hideAlipayWechatProfessionMerchant,
    formatPayments : isMerchant ? merchantPayments : normalPayments,
    userPayments,
    merchantPayments,
    normalPayments
  }
};

export const cryptoTradingStore: StateCreator<any> = (set, get) => {
  

  const updateQRcode =  (str: string) => {
    const { cryptoAccountInfo } = get();
    QRCode.toDataURL(str || cryptoAccountInfo.address).then((url) => {
      const $QRcode = document.querySelector(".QRcode");
      $QRcode && $QRcode.setAttribute("src", url);
    });
  }
  
  const fetchDepositDetail = async (isBuyVb: boolean = false, orderType: string) => {
    //是否购买V币  true amount为amount  否则 copeAmount
    set({loading:true});
    const { ok, data, msg } = await getDepositDetail({ orderType });
    const {fetchDepositDetail, timer} = get();
    if (ok) {
      if (data) {
        // 有未完成的订单
        set({
          orderInfo: data.order,
          form: {
            amount: isBuyVb ? data.order.amount : data.order.copeAmount,
            paymentType: data.order.paymentType
          },
          cryptoAccountInfo:{
            address: data.order.receivingAddress,
            otcTicker: parseFloat(
              String(data.order.amount / data.order.copeAmount)
            ).toFixed(2)
          }
        });
        updateQRcode(data.address);
        // 订单超时
        if (data.currentStateExpireTime) {
          let nextCountdown = 0;
          let nextTimer = null;
          if (data.currentStateExpireTime.expire) {
            const now = getServerTime();
            nextCountdown = data.currentStateExpireTime.expire * 1000 - now;
            // 如果可以倒计时
            if (nextCountdown > 0) {
              if(timer){
                clearTimeout(timer);
                
              }
              nextTimer = setTimeout(() => fetchDepositDetail(isBuyVb, orderType), 5000);
              set({countdown: nextCountdown, timer: nextTimer});
              
            }else{
              clearTimeout(timer);
              set({countdown:0, timer: null});
            }
          } else {
            clearTimeout(timer);
            set({countdown:0, timer: null});
          }
        }
      } else {
        // 没有未完成的订单
        clearTimeout(timer);
        set({countdown:0, timer: null});
      }
    } else {
      Toast.show(msg);
    }
  };

  const businessGetAccountInfo = async (val: string) => {
    const { ok, data, msg, ...rest } = await _businessGetAccountInfo({ type: val });
    if (ok) {
      set({ cryptoAccountInfo: data });
      updateQRcode(data.address);
    } else {
      Toast.show(msg);
    }

    return { ok, data, msg, ...rest };
  };
  return {
    loading: true,
    countdown: 0,
    form: {
      paymentType: "",
      amount: "",
    },
    orderInfo: {
      userId: null,
      paymentType: "",
      amount: "",
      passageType: "",
      receivingAddress: "",
      copeAmount: 0,
      createDate: "",
      status: "",
      createTime: "",
      updateTime: "",
      orderId: 0,
      orderNo: "",
    },
    cryptoAccountInfo:{
      address: "",
      otcTicker: ""
    },
    timer: null, 
    fetchDepositDetail,
    businessGetAccountInfo
    
  }
}

export const useCryptoTradingStore = create<any>(cryptoTradingStore);

export const useCryptoTradingContext = () => {
  const store = useCryptoTradingStore();
  useUnmount(()=> {
    store.timer && clearTimeout(store.timer);
  })
  return store
}

